import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Typography,
    Paper,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    IconButton,
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RouteIcon from '@mui/icons-material/Route';
import SpeedIcon from '@mui/icons-material/Speed';
import BuildIcon from '@mui/icons-material/Build';

// ─── Stat Cards ───────────────────────────────────────────────────────────────

const statCards = [
    { label: 'Total Buses', value: '342', sub: '— vs Previous Period', up: null, color: '#1976d2', bg: '#e3f2fd', icon: <DirectionsBusIcon sx={{ fontSize: 22, color: '#1976d2' }} /> },
    { label: 'Total Revenue (MTD)', value: 'Rs. 124,560,850', sub: '▲ 12.5% vs Previous Period', up: true, color: '#2e7d32', bg: '#e8f5e9', icon: <AttachMoneyIcon sx={{ fontSize: 22, color: '#2e7d32' }} /> },
    { label: 'Avg Revenue per Trip', value: 'Rs. 4,152.03', sub: '▲ 8.3% vs Previous Period', up: true, color: '#5c35a0', bg: '#ede7f6', icon: <ReceiptIcon sx={{ fontSize: 22, color: '#5c35a0' }} /> },
    { label: 'Total Trips', value: '28,450', sub: '▲ 9.7% vs Previous Period', up: true, color: '#ed6c02', bg: '#fff3e0', icon: <RouteIcon sx={{ fontSize: 22, color: '#ed6c02' }} /> },
    { label: 'Avg Utilization', value: '78.4%', sub: '▲ 4.6% vs Previous Period', up: true, color: '#d32f2f', bg: '#ffebee', icon: <SpeedIcon sx={{ fontSize: 22, color: '#d32f2f' }} /> },
    { label: 'Total Downtime', value: '1,245 hrs', sub: '▼ 6.2% vs Previous Period', up: false, color: '#00838f', bg: '#e0f7fa', icon: <BuildIcon sx={{ fontSize: 22, color: '#00838f' }} /> },
];

// ─── Bus Profitability rows ───────────────────────────────────────────────────

const busRows = [
    { no: 1, bus: 'NB-2567', depot: 'Colombo Depot', trips: 125, revenue: 625450, avgRev: 5003.60, passengers: 2854, revPerKm: 72.45, util: 88.4, downtime: 3.2, rank: 1 },
    { no: 2, bus: 'NB-3344', depot: 'Kandy Depot', trips: 118, revenue: 582340, avgRev: 4935.08, passengers: 2612, revPerKm: 68.70, util: 85.7, downtime: 3.6, rank: 2 },
    { no: 3, bus: 'NB-1123', depot: 'Kurunegala Depot', trips: 112, revenue: 545760, avgRev: 4872.86, passengers: 2430, revPerKm: 66.20, util: 82.9, downtime: 4.1, rank: 3 },
    { no: 4, bus: 'NB-9901', depot: 'Matara Depot', trips: 108, revenue: 502890, avgRev: 4656.39, passengers: 2210, revPerKm: 61.75, util: 80.3, downtime: 4.7, rank: 4 },
    { no: 5, bus: 'NB-7782', depot: 'Galle Depot', trips: 105, revenue: 487320, avgRev: 4640.19, passengers: 2180, revPerKm: 60.10, util: 79.8, downtime: 4.3, rank: 5 },
    { no: 6, bus: 'NB-8891', depot: 'Batticaloa Depot', trips: 98, revenue: 420560, avgRev: 4291.43, passengers: 1945, revPerKm: 58.30, util: 74.6, downtime: 5.8, rank: 6 },
    { no: 7, bus: 'NB-6673', depot: 'Jaffna Depot', trips: 92, revenue: 395210, avgRev: 4295.76, passengers: 1820, revPerKm: 57.05, util: 72.1, downtime: 6.2, rank: 7 },
    { no: 8, bus: 'NB-4455', depot: 'Anuradhapura Depot', trips: 88, revenue: 365480, avgRev: 4153.18, passengers: 1680, revPerKm: 55.40, util: 70.5, downtime: 6.7, rank: 8 },
    { no: 9, bus: 'NB-2234', depot: 'Puttalam Depot', trips: 85, revenue: 325640, avgRev: 3831.06, passengers: 1510, revPerKm: 52.20, util: 68.3, downtime: 7.6, rank: 9 },
    { no: 10, bus: 'NB-5566', depot: 'Hambantota Depot', trips: 78, revenue: 298750, avgRev: 3829.49, passengers: 1390, revPerKm: 50.15, util: 66.2, downtime: 8.4, rank: 10 },
    { no: 11, bus: 'NB-3312', depot: 'Negombo Depot', trips: 74, revenue: 276340, avgRev: 3733.51, passengers: 1280, revPerKm: 48.90, util: 64.8, downtime: 8.9, rank: 11 },
    { no: 12, bus: 'NB-6678', depot: 'Galle Depot', trips: 70, revenue: 254120, avgRev: 3630.29, passengers: 1170, revPerKm: 46.70, util: 62.5, downtime: 9.3, rank: 12 },
    { no: 13, bus: 'NB-1456', depot: 'Kandy Depot', trips: 68, revenue: 241890, avgRev: 3557.21, passengers: 1120, revPerKm: 45.30, util: 61.2, downtime: 9.8, rank: 13 },
    { no: 14, bus: 'NB-2210', depot: 'Colombo Depot', trips: 65, revenue: 228450, avgRev: 3514.62, passengers: 1060, revPerKm: 43.80, util: 59.7, downtime: 10.2, rank: 14 },
    { no: 15, bus: 'NB-7890', depot: 'Matara Depot', trips: 62, revenue: 215670, avgRev: 3478.55, passengers: 990, revPerKm: 42.10, util: 58.3, downtime: 10.7, rank: 15 },
    { no: 16, bus: 'NB-4421', depot: 'Kurunegala Depot', trips: 59, revenue: 198340, avgRev: 3361.69, passengers: 930, revPerKm: 40.50, util: 56.8, downtime: 11.1, rank: 16 },
    { no: 17, bus: 'NB-5534', depot: 'Jaffna Depot', trips: 56, revenue: 182560, avgRev: 3260.00, passengers: 870, revPerKm: 38.90, util: 55.2, downtime: 11.6, rank: 17 },
    { no: 18, bus: 'NB-8823', depot: 'Batticaloa Depot', trips: 52, revenue: 165230, avgRev: 3177.50, passengers: 810, revPerKm: 37.20, util: 53.7, downtime: 12.2, rank: 18 },
    { no: 19, bus: 'NB-3367', depot: 'Anuradhapura Depot', trips: 49, revenue: 148920, avgRev: 3039.18, passengers: 750, revPerKm: 35.60, util: 52.1, downtime: 12.8, rank: 19 },
    { no: 20, bus: 'NB-6645', depot: 'Puttalam Depot', trips: 46, revenue: 132450, avgRev: 2879.35, passengers: 690, revPerKm: 33.90, util: 50.4, downtime: 13.5, rank: 20 },
];

// ─── Schedule Performance rows ────────────────────────────────────────────────

const scheduleRows = [
    { no: 1, route: 'R-001', schCode: 'SCH-001-06:00', depTime: '06:00', direction: 'Outbound', depot: 'Colombo Depot', trips: 30, passengers: 1920, loadFactor: 78.5, revenue: 135240, avgRev: 4508.00, onTime: 94.3, cancellations: 1, rank: 1 },
    { no: 2, route: 'R-001', schCode: 'SCH-001-18:00', depTime: '18:00', direction: 'Inbound', depot: 'Colombo Depot', trips: 30, passengers: 1815, loadFactor: 74.2, revenue: 128560, avgRev: 4285.33, onTime: 92.6, cancellations: 2, rank: 2 },
    { no: 3, route: 'R-017', schCode: 'SCH-017-07:00', depTime: '07:00', direction: 'Outbound', depot: 'Kandy Depot', trips: 30, passengers: 1740, loadFactor: 71.5, revenue: 121860, avgRev: 4062.00, onTime: 91.2, cancellations: 1, rank: 3 },
    { no: 4, route: 'R-017', schCode: 'SCH-017-16:30', depTime: '16:30', direction: 'Inbound', depot: 'Kandy Depot', trips: 30, passengers: 1690, loadFactor: 69.4, revenue: 116420, avgRev: 3880.67, onTime: 90.1, cancellations: 2, rank: 4 },
    { no: 5, route: 'R-025', schCode: 'SCH-025-08:00', depTime: '08:00', direction: 'Outbound', depot: 'Kurunegala Depot', trips: 30, passengers: 1650, loadFactor: 70.6, revenue: 112340, avgRev: 3744.67, onTime: 89.3, cancellations: 1, rank: 5 },
    { no: 6, route: 'R-025', schCode: 'SCH-025-17:30', depTime: '17:30', direction: 'Inbound', depot: 'Kurunegala Depot', trips: 30, passengers: 1580, loadFactor: 67.8, revenue: 106780, avgRev: 3559.33, onTime: 88.4, cancellations: 2, rank: 6 },
    { no: 7, route: 'R-003', schCode: 'SCH-003-06:30', depTime: '06:30', direction: 'Outbound', depot: 'Galle Depot', trips: 30, passengers: 1480, loadFactor: 63.9, revenue: 98450, avgRev: 3281.67, onTime: 87.1, cancellations: 2, rank: 7 },
    { no: 8, route: 'R-003', schCode: 'SCH-003-15:45', depTime: '15:45', direction: 'Inbound', depot: 'Galle Depot', trips: 30, passengers: 1420, loadFactor: 61.3, revenue: 94210, avgRev: 3140.33, onTime: 86.2, cancellations: 3, rank: 8 },
    { no: 9, route: 'R-085', schCode: 'SCH-085-09:00', depTime: '09:00', direction: 'Outbound', depot: 'Matara Depot', trips: 30, passengers: 1310, loadFactor: 59.2, revenue: 86540, avgRev: 2884.67, onTime: 85.6, cancellations: 2, rank: 9 },
    { no: 10, route: 'R-085', schCode: 'SCH-085-18:15', depTime: '18:15', direction: 'Inbound', depot: 'Matara Depot', trips: 30, passengers: 1260, loadFactor: 57.0, revenue: 82670, avgRev: 2755.67, onTime: 84.4, cancellations: 4, rank: 10 },
    { no: 11, route: 'R-042', schCode: 'SCH-042-07:30', depTime: '07:30', direction: 'Outbound', depot: 'Negombo Depot', trips: 28, passengers: 1190, loadFactor: 55.4, revenue: 76540, avgRev: 2733.57, onTime: 83.7, cancellations: 2, rank: 11 },
    { no: 12, route: 'R-042', schCode: 'SCH-042-17:00', depTime: '17:00', direction: 'Inbound', depot: 'Negombo Depot', trips: 28, passengers: 1140, loadFactor: 53.8, revenue: 72890, avgRev: 2603.21, onTime: 82.9, cancellations: 3, rank: 12 },
];

// ─── Pagination hook ──────────────────────────────────────────────────────────

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────

const BusProfitabilityPage = () => {
    const [depot, setDepot] = useState('');
    const [route, setRoute] = useState('');
    const [busType, setBusType] = useState('');
    const [fuelType, setFuelType] = useState('');
    const [status, setStatus] = useState('');
    const [busTopN, setBusTopN] = useState('20');
    const [schTopN, setSchTopN] = useState('20');

    const busPag = usePagination(10);
    const schPag = usePagination(10);

    const thSx = { py: 1 };
    const tdSx = { py: 0 };

    return (
        <Container component="main" maxWidth={false} sx={{ py: 0, px: { xs: 2, sm: 3 } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Header ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>Bus Profitability</Typography>
                </Box>

                {/* ── Filter Bar ── */}
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3,1fr)', md: 'repeat(5,1fr) auto auto' }, gap: 2, width: '100%', mb: 3, alignItems: 'center' }}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Depot</InputLabel>
                        <Select value={depot} onChange={e => setDepot(e.target.value)} label="Depot">
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="colombo">Colombo Depot</MenuItem>
                            <MenuItem value="kandy">Kandy Depot</MenuItem>
                            <MenuItem value="kurunegala">Kurunegala Depot</MenuItem>
                            <MenuItem value="matara">Matara Depot</MenuItem>
                            <MenuItem value="galle">Galle Depot</MenuItem>
                            <MenuItem value="negombo">Negombo Depot</MenuItem>
                            <MenuItem value="jaffna">Jaffna Depot</MenuItem>
                            <MenuItem value="batticaloa">Batticaloa Depot</MenuItem>
                            <MenuItem value="anuradhapura">Anuradhapura Depot</MenuItem>
                            <MenuItem value="puttalam">Puttalam Depot</MenuItem>
                            <MenuItem value="hambantota">Hambantota Depot</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel>Route</InputLabel>
                        <Select value={route} onChange={e => setRoute(e.target.value)} label="Route">
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="R-001">R-001 – Colombo – Kandy</MenuItem>
                            <MenuItem value="R-017">R-017 – Kandy – Kurunegala</MenuItem>
                            <MenuItem value="R-025">R-025 – Kurunegala – Puttalam</MenuItem>
                            <MenuItem value="R-003">R-003 – Kandy – Matale</MenuItem>
                            <MenuItem value="R-042">R-042 – Colombo – Negombo</MenuItem>
                            <MenuItem value="R-085">R-085 – Matara – Akuressa</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel>Bus Type</InputLabel>
                        <Select value={busType} onChange={e => setBusType(e.target.value)} label="Bus Type">
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="ac">AC</MenuItem>
                            <MenuItem value="non_ac">Non-AC</MenuItem>
                            <MenuItem value="semi_luxury">Semi Luxury</MenuItem>
                            <MenuItem value="luxury">Luxury</MenuItem>
                            <MenuItem value="intercity">Intercity</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel>Fuel Type</InputLabel>
                        <Select value={fuelType} onChange={e => setFuelType(e.target.value)} label="Fuel Type">
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="diesel">Diesel</MenuItem>
                            <MenuItem value="electric">Electric</MenuItem>
                            <MenuItem value="hybrid">Hybrid</MenuItem>
                            <MenuItem value="cng">CNG</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel>Status</InputLabel>
                        <Select value={status} onChange={e => setStatus(e.target.value)} label="Status">
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                            <MenuItem value="maintenance">Under Maintenance</MenuItem>
                        </Select>
                    </FormControl>
                    <Button variant="contained"
                        sx={{ borderRadius: '4px', textTransform: 'none', fontWeight: 'bold', height: 40, backgroundColor: '#3f51b5', '&:hover': { backgroundColor: '#303f9f' }, whiteSpace: 'nowrap', px: 3 }}>
                        Apply
                    </Button>
                    <Button variant="outlined"
                        sx={{ borderRadius: '4px', textTransform: 'none', fontWeight: 600, height: 40, whiteSpace: 'nowrap', px: 3 }}>
                        Reset
                    </Button>
                </Box>

                {/* ── Stat Cards (6 across) ── */}
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(3,1fr)', lg: 'repeat(6,1fr)' }, gap: 2, width: '100%', mb: 3 }}>
                    {statCards.map((card) => (
                        <Paper key={card.label} variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                <Box sx={{ backgroundColor: card.bg, borderRadius: 1.5, p: 0.5, display: 'flex', alignItems: 'center' }}>
                                    {card.icon}
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 11, lineHeight: 1.3 }}>{card.label}</Typography>
                            </Box>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: card.color, lineHeight: 1.2, mb: 0.5, fontSize: { xs: 15, lg: 14, xl: 16 } }}>
                                {card.value}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                {card.up === true && <TrendingUpIcon sx={{ fontSize: 13, color: '#2e7d32' }} />}
                                {card.up === false && <TrendingDownIcon sx={{ fontSize: 13, color: '#d32f2f' }} />}
                                <Typography variant="caption" sx={{ color: card.up === true ? '#2e7d32' : card.up === false ? '#d32f2f' : '#888', fontWeight: 600, fontSize: 11 }}>
                                    {card.sub}
                                </Typography>
                            </Box>
                        </Paper>
                    ))}
                </Box>

                {/* ══════════════════════════════════════════
                    TABLE 1 — Bus Profitability Summary
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>2.1 Bus Profitability Summary</Typography>
                    <FormControl size="small" sx={{ minWidth: 130 }}>
                        <Select value={busTopN} onChange={e => setBusTopN(e.target.value)} sx={{ fontSize: 13, height: 32 }}>
                            <MenuItem value="10">Show Top 10</MenuItem>
                            <MenuItem value="20">Show Top 20</MenuItem>
                            <MenuItem value="50">Show Top 50</MenuItem>
                            <MenuItem value="all">Show All</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>No.</TableCell>
                                <TableCell sx={thSx}>Bus No.</TableCell>
                                <TableCell sx={thSx}>Owning Depot</TableCell>
                                <TableCell sx={thSx}>Total Trips</TableCell>
                                <TableCell sx={thSx}>Total Revenue (Rs.)</TableCell>
                                <TableCell sx={thSx}>Avg Revenue per Trip (Rs.)</TableCell>
                                <TableCell sx={thSx}>Total Passengers</TableCell>
                                <TableCell sx={thSx}>Revenue per Km (Rs.)</TableCell>
                                <TableCell sx={thSx}>Utilization %</TableCell>
                                <TableCell sx={thSx}>Downtime %</TableCell>
                                <TableCell sx={thSx}>Rank</TableCell>
                                <TableCell sx={thSx} align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {busRows
                                .slice(busPag.startIndex, busPag.startIndex + busPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.bus} hover>
                                        <TableCell sx={tdSx}>{row.no}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.bus}</TableCell>
                                        <TableCell sx={tdSx}>{row.depot}</TableCell>
                                        <TableCell sx={tdSx}>{row.trips}</TableCell>
                                        <TableCell sx={tdSx}>{row.revenue.toLocaleString()}</TableCell>
                                        <TableCell sx={tdSx}>{row.avgRev.toFixed(2)}</TableCell>
                                        <TableCell sx={tdSx}>{row.passengers.toLocaleString()}</TableCell>
                                        <TableCell sx={tdSx}>{row.revPerKm.toFixed(2)}</TableCell>
                                        <TableCell sx={tdSx}>{row.util}%</TableCell>
                                        <TableCell sx={tdSx}>{row.downtime}%</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.rank}</TableCell>
                                        <TableCell sx={tdSx} align="right">
                                            <IconButton size="small" color="primary"><VisibilityIcon sx={{ fontSize: 18 }} /></IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={342}
                        page={busPag.page}
                        onPageChange={busPag.handleChangePage}
                        rowsPerPage={busPag.rowsPerPage}
                        onRowsPerPageChange={busPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    TABLE 2 — Schedule Performance Comparison
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, mt: 4 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>3.1 Schedule Performance Comparison</Typography>
                    <FormControl size="small" sx={{ minWidth: 130 }}>
                        <Select value={schTopN} onChange={e => setSchTopN(e.target.value)} sx={{ fontSize: 13, height: 32 }}>
                            <MenuItem value="10">Show Top 10</MenuItem>
                            <MenuItem value="20">Show Top 20</MenuItem>
                            <MenuItem value="50">Show Top 50</MenuItem>
                            <MenuItem value="all">Show All</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>No.</TableCell>
                                <TableCell sx={thSx}>Route Code</TableCell>
                                <TableCell sx={thSx}>Schedule Code</TableCell>
                                <TableCell sx={thSx}>Departure Time</TableCell>
                                <TableCell sx={thSx}>Direction</TableCell>
                                <TableCell sx={thSx}>Assigned Depot</TableCell>
                                <TableCell sx={thSx}>Total Trips</TableCell>
                                <TableCell sx={thSx}>Total Passengers</TableCell>
                                <TableCell sx={thSx}>Avg Load Factor %</TableCell>
                                <TableCell sx={thSx}>Total Revenue (Rs.)</TableCell>
                                <TableCell sx={thSx}>Avg Revenue per Trip (Rs.)</TableCell>
                                <TableCell sx={thSx}>On-Time %</TableCell>
                                <TableCell sx={thSx}>Cancellation Count</TableCell>
                                <TableCell sx={thSx}>Rank</TableCell>
                                <TableCell sx={thSx} align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {scheduleRows
                                .slice(schPag.startIndex, schPag.startIndex + schPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.schCode} hover>
                                        <TableCell sx={tdSx}>{row.no}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.route}</TableCell>
                                        <TableCell sx={tdSx}>{row.schCode}</TableCell>
                                        <TableCell sx={tdSx}>{row.depTime}</TableCell>
                                        <TableCell sx={tdSx}>{row.direction}</TableCell>
                                        <TableCell sx={tdSx}>{row.depot}</TableCell>
                                        <TableCell sx={tdSx}>{row.trips}</TableCell>
                                        <TableCell sx={tdSx}>{row.passengers.toLocaleString()}</TableCell>
                                        <TableCell sx={tdSx}>{row.loadFactor}%</TableCell>
                                        <TableCell sx={tdSx}>{row.revenue.toLocaleString()}</TableCell>
                                        <TableCell sx={tdSx}>{row.avgRev.toFixed(2)}</TableCell>
                                        <TableCell sx={tdSx}>{row.onTime}%</TableCell>
                                        <TableCell sx={tdSx}>{row.cancellations}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.rank}</TableCell>
                                        <TableCell sx={tdSx} align="right">
                                            <IconButton size="small" color="primary"><VisibilityIcon sx={{ fontSize: 18 }} /></IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={612}
                        page={schPag.page}
                        onPageChange={schPag.handleChangePage}
                        rowsPerPage={schPag.rowsPerPage}
                        onRowsPerPageChange={schPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

            </Box>
        </Container>
    );
};

export default BusProfitabilityPage;